/**
 * Theme styles for ::content syntax — header, close, body lines,
 * L0 pretty widgets, L2 mark decorations.
 */

import { EditorView } from "@codemirror/view";
import {
    accentIconStyles,
    accentText,
    directiveLineStyles,
    directivePrettyStyles,
} from "../shared/theme-helpers";

const CONTENT_ACCENT = "--cm-content-accent";

export const contentTheme = EditorView.baseTheme({
    /* L2: Content define header */
    ".cm-magic-content-head": {
        color: `var(${CONTENT_ACCENT})`,
        fontWeight: "500",
        letterSpacing: "0.02em",
    },
    /* L2: Content define close */
    ".cm-magic-content-close": {
        color: `var(${CONTENT_ACCENT})`,
        fontWeight: "500",
        opacity: "0.7",
    },
    /* L2: Content body area */
    ".cm-magic-content-body": {
        borderLeft:
            "2px solid color-mix(in oklab, var(--cm-content-accent) 30%, transparent)",
    },
    /* Background for all lines within a content block */
    ".cm-magic-content-line": directiveLineStyles(CONTENT_ACCENT, 6, 30),
    ".cm-magic-content-active .cm-magic-btn-group": {
        opacity: "1",
        maxWidth: "120px",
        pointerEvents: "auto",
    },
    /* Body lines get a double-line visual + indentation */
    ".cm-magic-content-body-line": {
        backgroundColor:
            "color-mix(in oklab, var(--cm-content-accent) 3%, transparent)",
        borderLeft:
            "2px double color-mix(in oklab, var(--cm-content-accent) 30%, transparent)",
    },
    /* Inner content-block content — extra left padding for visual nesting */
    ".cm-magic-content-inner": {
        paddingLeft: "40px !important",
    },
    /* L0: Pretty content define widget — header */
    ".cm-magic-content-pretty": directivePrettyStyles(CONTENT_ACCENT, {
        gap: "5px",
    }),
    ".cm-magic-content-pretty-border": accentIconStyles(CONTENT_ACCENT),
    ".cm-magic-content-pretty-label": {
        color: `var(${CONTENT_ACCENT})`,
        fontWeight: "500",
        fontSize: "12px",
    },
    ".cm-magic-content-pretty-id": accentText(CONTENT_ACCENT, {
        fontWeight: "600",
        letterSpacing: "0.01em",
    }),
    /* L0: Pretty content end widget */
    ".cm-magic-content-end": {
        display: "inline-flex",
        alignItems: "center",
        color: `var(${CONTENT_ACCENT})`,
        fontWeight: "500",
        fontSize: "13px",
        opacity: "0.7",
        fontFamily: "ui-sans-serif, system-ui, sans-serif",
    },
});
